import React from "react";
import { useStripeConfig } from "../../lib/stripe";

// Admin-console-only strip showing which Stripe keys the site is currently
// taking payments with. It rides under AdminHeader, so it appears on every
// admin page and nowhere else — end users never see it. Both states are shown
// deliberately: "live" is the one you want to notice before doing anything, and
// a silent banner would be indistinguishable from a broken one.
export default function AdminStripeModeBanner() {
  const { loading, mode, configured } = useStripeConfig();
  if (loading || !mode) return null;

  const test = mode === "test";
  return (
    <div style={{ ...styles.bar, ...(test ? styles.test : styles.live) }} role="status">
      <strong style={{ ...styles.tag, ...(test ? styles.tagTest : styles.tagLive) }}>
        STRIPE {mode.toUpperCase()} MODE
      </strong>
      <span>
        {test
          ? "Payments are simulated — no real card is charged and no money moves."
          : "Real cards are charged. Any payment taken on the site is real money."}
      </span>
      {!configured && <span style={styles.warn}>keys incomplete — the card form will not load</span>}
    </div>
  );
}

const styles = {
  bar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 10,
    padding: "7px 16px",
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: 12.5,
    lineHeight: 1.4,
    textAlign: "center",
  },
  test: { background: "#FEF3C7", borderBottom: "1px solid #FCD34D", color: "#78350F" },
  live: { background: "#DCFCE7", borderBottom: "1px solid #86EFAC", color: "#14532D" },
  tag: {
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 0.6,
    padding: "2px 8px",
    borderRadius: 999,
    whiteSpace: "nowrap",
  },
  tagTest: { background: "#78350F", color: "#FEF3C7" },
  tagLive: { background: "#14532D", color: "#DCFCE7" },
  warn: { fontWeight: 700, color: "#991b1b" },
};
